<template>
  <d2-container>
    <template slot="header">
      <el-input
        @keyup.enter.native="getSearch(1)"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入属性id"
        size="small"
        v-model="listQuery.attrId"
        :clearable="true"
      ></el-input>
      <el-input
        @keyup.enter.native="getSearch(1)"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入证书id"
        size="small"
        v-model="listQuery.userCertId"
        :clearable="true"
      ></el-input>
      <el-button @click="getSearch(1)" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="baseList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证书id">
        <template slot-scope="scope">
          <span>{{ scope.row.userCertId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="属性id">
        <template slot-scope="scope">
          <span>{{ scope.row.attrId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="第三方昵称">
        <template slot-scope="scope">
          <span>{{ scope.row.thirdNickname }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="粉丝数量">
        <template slot-scope="scope">
          <span>{{scope.row.followCount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="第三方平台id">
        <template slot-scope="scope">
          <span>{{ scope.row.thirdAccountId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="作品链接" width="380">
        <template slot-scope="scope">
          <span class="soan" v-for="(item,index) in scope.row.worksUrl" :key="index">{{ item }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="主页截图" width="380">
        <template slot-scope="scope">
          <!-- <img class="img" v-for="(item,index) in scope.row.screenshot" :key="index" :src="item" alt=""> -->
          <span v-for="(item,index) in scope.row.screenshot" :key="index">
            <el-popover placement="left" trigger="click" width="400">
              <img :src="item" width="400px" />
              <img slot="reference" :src="item" :alt="item" class="img" />
            </el-popover>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span>{{ scope.row.status == 0 ?'未审核':'已审核' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="danger"
            @click="getExamine(scope.row.id)"
            style="margin-top: 10px;"
            v-permission:function="['examineListDManger:btn_examine']"
            :disabled="scope.row.status == 1 ? true : false"
          >审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
    <el-dialog title="审核" :visible.sync="centerDialogVisible" width="40%" center>
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="评分" class="score" required prop="value">
          <!-- <el-rate style="margin-top: 11px;" v-model="form.value" show-text></el-rate> -->
          <el-input v-model.number="form.value" placeholder="请输入评分数值"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getDetermine">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getAttrList, getAttrAudit } from '@/api/demo/certificateList/index'
export default {
  name: 'examineListDManger',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      examineListDManger_btn_examine: false,
      tableKey: 0,
      closeData: [], // 数据
      total: null,
      baseList: [], // 基础属性集合
      certId: '', // 证书id
      attributeId: '', // 属性id
      attribute: '',
      centerDialogVisible: false,
      form: {
        value: null,
        remark: '',
        id: null
      },
      listQuery: {
        attrId: null, // 属性id
        userCertId: null, // 用户亲密证书id
        currentPage: 1,
        pageSize: 20
      },
      rules: {
        value: [
          { required: true, message: '评分不能为空' },
          { type: 'number', message: '评分必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    $route (to, from) {}
  },
  created () {
    if (this.$route.query.id != null) {
      this.listQuery.userCertId = this.$route.query.id
    }
    this.getSearch()
  },
  mounted () {
    this.getSearch()
  },
  methods: {
    // 搜索条件
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getAttrList(that.listQuery).then(res => {
        that.listLoading = true
        res.records.forEach(item => {
          item.screenshot = item.screenshot.split(',')
          item.worksUrl = item.worksUrl.split(',')
        })
        console.log('res', res.records)
        that.baseList = res.records.reverse()
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    // 审核
    getExamine (id) {
      let that = this
      that.form.id = id
      that.centerDialogVisible = true
    },
    // 审核确定
    getDetermine () {
      let that = this
      getAttrAudit(that.form).then(res => {
        that.getSearch()
        that.centerDialogVisible = false
        that.$notify({
          title: '成功',
          message: '审核成功',
          type: 'success',
          duration: 2000
        })
      })
    }
  }
}
</script>

<style scoped>
.baseList {
  display: flex;
}
.baseList span {
  padding: 10px 20px;
  width: 180px;
  display: block;
}
.soan {
  padding: 5px 12px;
  display: block;
}
.img {
  padding: 5px 10px;
  width: 70px;
  height: 70px;
}
.score {
}
</style>
